// Утилита для форматирования строки даты в объект dayjs

import dayjs from 'dayjs';

import type { Dayjs } from 'dayjs';

export const formatStringDateToDayjs = (
  date: string | null,
  format = 'YYYY-MM-DD'
): Dayjs | null => (date ? dayjs(date, format) : null);
